<template>
  <NuxtLink
    class="flex size-9 items-center justify-center text-size-7"
    :to="to"
    :class="{
      'bg-primary text-scheme-main': isCurrent,
      'hover:bg-scheme-main': !isCurrent,
    }"
  >
    {{ page }}
  </NuxtLink>
</template>

<script lang="ts" setup>
const props = defineProps<{
  page: number
  isCurrent?: boolean
}>()

const route = useRoute()

const to = computed(() => {
  const page = props.page - 1
  return {
    query: {
      ...route.query,
      page: page === 0 ? undefined : page.toString(),
    },
  }
})
</script>
